export enum TypeNumberAccount {
    INTERBANK = 'interbank',
    BANK = 'bank'
}
